import { styled } from "@mui/material/styles";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { Close, EastOutlined } from "@mui/icons-material";
import { colors } from "../../../theme/theme";

export const RootWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isOver",
})(({ isOver, theme }) => ({
  width: "310px",
  backgroundColor: isOver ? "#e0f7fa" : "transparent",
  [theme.breakpoints.down(1130)]: {
    margin: "auto",
  },
}));

export const EmptyStateBox = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(41, 64, 90, 0.03)",
  borderRadius: theme.spacing(2),
  padding: 16,
  border: `1px dashed ${colors.lightBorder}`,
}));

export const EmptyStateText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "14px",
  color: theme.palette.text.primary,
}));

export const StyledList = styled(List)({
  width: "100%",
  margin: 0,
  padding: 0,
});

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  borderBottom: `0.5px solid ${theme.palette.text.primary}`,
  "&.Mui-selected:hover": {
    backgroundColor: "transparent",
  },
  "&:hover": {
    backgroundColor: "transparent",
  },
  display: "flex",
  alignItems: "center",
}));

export const ItemText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: theme.spacing(2),
  color: theme.palette.text.primary,
}));

export const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: 0,
});

export const StyledEastOutlined = styled(EastOutlined)(({ theme }) => ({
  minWidth: "40px",
  color: theme.palette.text.primary,
}));

export const StyledClose = styled(Close)(({ theme }) => ({
  fontSize: "22px",
  color: theme.palette.text.primary,
}));
